<template>
  <router-link tag="a" :to="{name: 'RegisterContents'}" class="content-card-list-content">
    <div class="content-card-list-content--reference">
      <h3>Primeiro dia</h3>
    </div>
    <div class="content-card-list-content--description">
      <h2>O que é a Procastinação?</h2>
      <p>Procrastinação é o diferimento ou adiamento de uma ação. Para a pessoa que está a procrastinar...</p>
    </div>
    <button class="content-card-list-content--btn">
      <p>Acessar</p>
      <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_25_130" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="6" height="11">
        <path d="M0 10.5715H6L6 0.751996H0L0 10.5715Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_25_130)">
        <path d="M5.78032 6.15696C6.07323 5.88307 6.07323 5.43826 5.78032 5.16438L1.2812 0.957382C0.9883 0.683502 0.5126 0.683502 0.2197 0.957382C-0.0732503 1.23131 -0.0732503 1.67607 0.2197 1.95L4.18922 5.66174L0.22205 9.37353C-0.0709 9.64742 -0.0709 10.0922 0.22205 10.3661C0.51495 10.64 0.99065 10.64 1.28354 10.3661L5.78266 6.15914L5.78032 6.15696Z" fill="black"/>
        </g>
      </svg>
    </button>
  </router-link>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.content-card-list-content {
  display: block;
  padding: 15px;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(0,0,0,0.25);
  border-radius: 10px;
  margin-bottom: 30px;
  transition: 500ms;
  &:hover,&:focus {
    cursor: pointer;
    opacity: 0.6;
  }
  &--reference {
    text-align: left;
    margin-bottom: 20px;
    h3 {
      font-size: 14px;
      font-family: 'Font Light Italic';
      color: var(--gray-dark);
      margin-bottom: 0;
    }
  }
  &--description {
    text-align: left;
    h2 {
      font-size: 16px;
      font-family: 'Font Regular';
      color: var(--black);
      margin-bottom: 10px;
      @media (min-width: 577px){
        height: 40px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
    p {
      font-size: 14px;
      font-family: 'Font Light';
      color: var(--black);
      margin-bottom: 0;
      @media (min-width: 577px){
        height: 65px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
  &--btn {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--yellow);
    border: 0;
    border-radius: 30px;
    padding: 0px 15px;
    margin: 15px auto 0px auto;
    p {
      font-size: 16px;
      font-family: 'Font Semibold';
      color: var(--black);
      margin-bottom: 0;
    }
  }
}
</style>
